import type { Document as RichTextDocument } from '@contentful/rich-text-types';
// biome-ignore lint/correctness/noUnusedImports: Automated migration to Biome
import React from 'react';
import { getFrontifyBackgroundImageUrl, setImgWidth } from '@/utils/frontify';
import type { GoogleUrls } from '../../constants/baseUrls';
import type {
  Contentful,
  FrontifyImageContent,
} from '../../contentful/contentful-exports';
import type { LeadFormType } from '../../enums/FormType';
import type { DialogContent } from '../FormResultDialog/FormResultDialog';
import useStyles from './LeadFormSection.styles';
import LeadFormV2 from './LeadFormV2/LeadFormV2';

export interface LeadFormSectionContent extends Contentful {
  fields: {
    campaignId: string;
    title: string;
    subtitle: string;
    titleImage: FrontifyImageContent[];
    tos: RichTextDocument;
    leadCreatedTitle: string;
    leadCreatedSubtitle: string;
    leadCreatedDetails: string;
    leadCreatedImage: FrontifyImageContent[];
    solarIncentivesList: string[];
    hideNumbers?: boolean;
    leadFormType: LeadFormType;
    googleSheetUrls?: GoogleUrls;
    formImageAltText?: string;
  };
}

interface Props {
  content: LeadFormSectionContent;
}

/**
 * @deprecated V2 component
 */
export default function LeadFormSection({ content }: Props) {
  const { classes } = useStyles();

  const {
    campaignId,
    title,
    subtitle,
    titleImage,
    solarIncentivesList = [],
    tos,
    leadCreatedTitle,
    leadCreatedSubtitle,
    leadCreatedDetails,
    leadCreatedImage,
    hideNumbers,
    leadFormType,
    googleSheetUrls,
    formImageAltText,
  } = content?.fields || {};

  const leadCreatedImagePath = getFrontifyBackgroundImageUrl(
    leadCreatedImage?.[0].preview_url,
    1440
  );

  const dialogContent: DialogContent = {
    title: leadCreatedTitle,
    subtitle: leadCreatedSubtitle,
    details: leadCreatedDetails,
    imagePath: leadCreatedImagePath,
  };

  return (
    <div className={classes.leadSection}>
      <div className={classes.leadTextContainer}>
        <div>
          <h1 className={classes.leadTitle}>{title}</h1>
          {subtitle && <h3 className={classes.subtitle}>{subtitle}</h3>}
        </div>
        {titleImage && (
          <div className={classes.leadSubtitleContainer}>
            {/** biome-ignore lint/performance/noImgElement: Automated migration to Biome */}
            <img
              className={classes.subtitleImage}
              src={setImgWidth(titleImage[0].preview_url, 1440)}
              alt={formImageAltText}
            />
          </div>
        )}
        {/** biome-ignore lint/suspicious/noDoubleEquals: Automated migration to Biome */}
        {hideNumbers != true && solarIncentivesList.length > 0 && (
          <div className={classes.listContainer}>
            {solarIncentivesList.map((solarIncentive, index) => (
              <div className={classes.listItem} key={solarIncentive}>
                <div className={classes.listElement}>{index + 1}</div>
                <span className={classes.listTitle}>{solarIncentive}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <LeadFormV2
        campaignId={campaignId}
        tos={tos}
        dialogContent={dialogContent}
        leadFormType={leadFormType}
        googleSheetUrls={googleSheetUrls}
      />
    </div>
  );
}
